//CONSTS
const apiRef = 'https://shopweruva.myshopify.com/api/2023-04/graphql';
const accessToken = 'bc6966147a5e6a02ee257c3f56f9e611';
//GLOBAL VARS
var variantChanger, quickviewForm, quickfindDealerBtn, quickfindPrice, quickfindBackorder;

//REQUEST VARIANT INFO
async function getProductMetafieldInfo(variantId) {
    //HEADERS
    const headers = new Headers({
      "Content-Type": "application/json",
      Accept: "application/json",
      "X-Shopify-Storefront-Access-Token": accessToken
    });
    //VARIANT ID
    var the_var = "gid://shopify/ProductVariant/"+variantId;
    //GRAPHQL QUERY
    const query = `
        {
            node(id: "${the_var}") {
                ... on ProductVariant {
                    title
                    id
                    dtc: metafield(namespace: "custom", key: "dtc") {
                        value
                    }
                }
            }
        }
    `;
    //FETCH
    fetch(apiRef, {
      method: "POST",
      headers: headers,
      body: JSON.stringify({
        query: query
      }),
    })
    //RESPONSE
    .then((response) => response.json())
        .then((data) => {
        //CHECK IF THE CURRENT IS DTC
        isCurrentDTC(data);
    })
    //ERR
    .catch((err) => {
        console.log("error", err);
    });
}

//CHECKS IF CURRENT IS DTC
function isCurrentDTC(data) {
    var dtcNode = data.data.node.dtc;
    //IF CURRENT IS DTC - THEN SWAP OUT FORM
    if(dtcNode == null) {
        noDTC();
    } else {
        var dtcValue = dtcNode.value;
        //IF DTC PRESENT HIDE OR SHOW
        if (dtcValue === 'true') {
            hasDTC();
        } else {
            noDTC();
        }
    }
}

//OBSERVE MODAL ACTIVATION
function observeModalActivation() {
    //CONST
    const modalQuick = document.querySelector('quick-add-drawer');
    //IF MODAL IS PRESENT
    if (modalQuick) {
        //OBSERVER CONST - LOOKS FOR CHANGE IN CLASS
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                //IF QUICKVIEW MODAL IS OPEN
                if (mutation.type === 'attributes' && mutation.attributeName === 'open' && mutation.target.ariaHidden === 'false') {
                    //WAIT GET VARIANT CHANGER AND WATCH FOR CHANGES
                    function checkVariantChanger(retryCount = 0) {
                        if (retryCount >= 3) { // Adjust this value based on how many retries you want to allow
                            console.error('Variant changer not found after multiple retries');
                            return;
                        }
                        //WAIT FOR VARIANT CHANGER
                        setTimeout(function () {
                            variantChanger = document.querySelector('quick-add-drawer product-form input[name="id"]');
                            if (variantChanger) {
                                //UPDATE FORM
                                updateQuickview();
                                //ATTACH EVENT
                                attachVariantChangerEvent(variantChanger);
                            } else {
                                checkVariantChanger(retryCount + 1);
                            }
                        }, 500); // Delay between retries
                    }
                    checkVariantChanger();
                    //IF QUICKVIEW MODAL IS CLOSED
                } else if (mutation.type === 'attributes' && mutation.attributeName !== 'open' && mutation.target.ariaHidden === 'true') {
                    //TRANSITION/CLOSE OUT
                    setTimeout(function () {
                        changeDTC();
                    }, 500);
                }
            });
        });
        //CONFIG & START OBSERVING CHANGE OF CLASS ATT
        observer.observe(modalQuick, { attributes: true });
    }
}

//DOM LOADED - START OBSERVING MODAL ACTIVATION
document.addEventListener("DOMContentLoaded", function() {
    observeModalActivation();
});

//UPDATE QUICKVIEW FORM
function updateQuickview() {
    //VARIANTID THEN GET DTC INFO
    var variantId = document.querySelector('quick-add-drawer product-form input[name="id"]').value;
    //console.log('updateQuickview', variantId);
    getProductMetafieldInfo(variantId);
}

//VARIANT CHANGER EVENT
function attachVariantChangerEvent(variantChanger) {
    if (variantChanger) {
        // OBSERVER FOR CHANGE IN VARIANT CHANGER
        valueObserver = new MutationObserver(() => {
            // UPDATE FORM
            updateQuickview();
        });
        //CONFIG & START OBSERVING CHANGES OF ATT VALUE
        valueObserver.observe(variantChanger, { attributes: true, attributeFilter: ['value'] });
    } else {
        console.log('variantChanger not found');
    }
}

//UPDATE VARS WHEN WE NEED
function getDTCVars(retryCount = 0) {
    quickviewForm = document.querySelector('quick-add-drawer product-form .pdp-dtc-form');
    quickfindDealerBtn = document.querySelector('quick-add-drawer product-form .update-dtc-var');
    quickfindPrice = document.querySelector('quick-add-drawer .product-price');
    quickfindBackorder = document.querySelector('quick-add-drawer .product-backorder');
    if ((!quickviewForm || !quickfindDealerBtn || !quickfindPrice) && retryCount < 3) {
        setTimeout(() => getDTCVars(retryCount + 1), 200);
    } else if (retryCount >= 3) {
        console.error('Some elements not found after multiple retries');
    }
}

//HAS DTC
function hasDTC() {
    getDTCVars();
    //MAKE SURE WE GOT ELEMENTS
    const checkInterval = setInterval(() => {
        if (quickviewForm && quickfindDealerBtn && quickfindPrice) {
            clearInterval(checkInterval);
            // HIDE/SHOW
            quickviewForm.style.display = "block";
            quickfindPrice.style.display = "block";
            quickfindBackorder.style.display = "block";
            quickfindDealerBtn.style.display = "none";
        }
    }, 200);
}
//NO DTC
function noDTC() {
    getDTCVars();
    //MAKE SURE WE GOT ELEMENTS
    const checkInterval = setInterval(() => {
        if (quickviewForm && quickfindDealerBtn && quickfindPrice) {
            clearInterval(checkInterval);
            // HIDE/SHOW
            quickviewForm.style.display = "none";
            quickfindPrice.style.display = "none";
            quickfindBackorder.style.display = "none";
            quickfindDealerBtn.style.display = "block";
        }
    }, 200);
}
//USED FOR TRANSITION SO NO JUMPING
function changeDTC() {
    getDTCVars();
    //MAKE SURE WE GOT ELEMENTS
    const checkInterval = setInterval(() => {
        if (quickviewForm && quickfindDealerBtn && quickfindPrice) {
            clearInterval(checkInterval);
            // HIDE/SHOW
            if (quickviewForm != null) {
                quickviewForm.style.display = "none";
            }
            if (quickfindPrice != null) {
                quickfindPrice.style.display = "none";
            }
            if (quickfindBackorder != null) {
                quickfindBackorder.style.display = "none";
            }
            if (quickfindDealerBtn != null) {
                quickfindDealerBtn.style.display = "none";
            }
        }
    }, 200);
}